import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class taskInfoButtonCtrl implements IController {

  task: TaskModel;
  purpose: any;

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  taskInfoPopup(event) {

    event.stopPropagation();

    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: '<task-info-card aria-label="taskInfoDialog" class="task-info-dialog" task="task"></task-info-card>',
      controller: this.TaskInfoPopupController,
      locals: {task: this.task},
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  TaskInfoPopupController = function (task, $scope) {
    $scope.task = task;
  };

}

angular
  .module('bringoz.admin.tasks')
  .component('taskInfoButton', {
    bindings: {
      task: '<?',
      purpose: '<?'
    },
    template: require('./task-info-button.html').default,
    controller: taskInfoButtonCtrl
  });
